import {
  Button,
  Gutter,
  Layout,
  LayoutItem,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalSection,
} from '@axiom/ui';
import React, { useEffect, useRef } from 'react';

export interface DirectEngagementsFormWorksiteModalProps {
  onClose: () => void;
  onChangeToRemote: () => Promise<void>;
}

export const DirectEngagementsFormWorksiteModal: React.FC<
  DirectEngagementsFormWorksiteModalProps
> = ({ onClose, onChangeToRemote }) => {
  const worksiteSelectionRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (worksiteSelectionRef.current) {
      // Adding focus on the modal to prevent user interacting with background form while modal is open
      worksiteSelectionRef.current.focus();
    }
  }, []);

  return (
    <Modal name="worksite-modal">
      <ModalHeader
        name="worksite-modal-header"
        onClose={() => {
          onClose();
        }}
      >
        Consider this change to improve your matches
      </ModalHeader>
      <div
        tabIndex={-1}
        ref={worksiteSelectionRef}
        data-test="worksite-modal-ref"
      />
      <ModalSection name="worksite-modal-section">
        Limiting work location to onsite or hybrid may reduce the number of
        available talent. Would you consider offering remote work to get more
        matches?
      </ModalSection>
      <ModalFooter>
        <Layout
          position="space-between middle"
          stretched
          reversibleOn="mobile"
          stackableOn="mobile"
        >
          <LayoutItem stretched fluid>
            <Button
              name="keep-onsite-hybrid-button"
              variation="minimal"
              onClick={() => {
                onClose();
              }}
            >
              keep onsite/hybrid
            </Button>
          </LayoutItem>
          <Gutter bottom="16px" only="mobile" />
          <LayoutItem stretched fluid>
            <Button
              name="change-to-remote-button"
              variation="filled"
              pattern="primary"
              onClick={async () => {
                await onChangeToRemote();
                onClose();
              }}
            >
              change to remote
            </Button>
          </LayoutItem>
        </Layout>
      </ModalFooter>
    </Modal>
  );
};
